import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ItemCard.css';
import buildImageUrl from '../utils/imageUrl';

const ItemCard = ({ item }) => {
  const primaryImage = item.images?.find((img) => img.is_primary) || item.images?.[0];
  const [hasImageError, setHasImageError] = useState(false);
  const imageUrl = buildImageUrl(primaryImage?.image_url);

  useEffect(() => {
    setHasImageError(false);
  }, [imageUrl]);

  return (
    <Link to={`/item/${item.id}`} className="item-card">
      <div className="item-image-container">
        {imageUrl && !hasImageError ? (
          <img
            src={imageUrl}
            alt={item.name}
            className="item-image"
            onError={() => setHasImageError(true)}
          />
        ) : (
          <div className="item-image-placeholder">No Image</div>
        )}
      </div>
      <div className="item-info">
        <h3 className="item-name">{item.name}</h3>
        {item.category && <p className="item-category">{item.category}</p>}
        <p className="item-price">${item.price.toFixed(2)}</p>
        {item.stock_quantity <= 0 && (
          <span className="out-of-stock">Out of Stock</span>
        )}
      </div>
    </Link>
  );
};

export default ItemCard;
